export default __webpack_public_path__ + "static/webRotator/svg/59fb592715fe856cfca662ce077b68a0.svg";